import Prose from "./Prose";

// Long-form rich text (e.g. terms) renders through Prose at its default `regular` scale.
// A named alias so callers read as "long-form text" rather than the lower-level Prose.
const Text = Prose;

export default Text;
